import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TwiztedTow from "@/pages/TwiztedTow";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TwiztedTow />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
